module.exports = __webpack_public_path__ + "img/horn4.48955b79.png";